import { HttpClient, robotoHeaders } from "@/shared/http";

import { MeteringReport } from "./MeteringReport";

export class MeteringService {
  #httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.#httpClient = httpClient;
  }

  async getMeteringReportForOrg(
    orgId: string,
    options?: Partial<{
      abortSignal: AbortSignal;
      searchParams: URLSearchParams;
    }>,
  ): Promise<MeteringReport | MeteringReport[]> {
    const url = this.#httpClient.constructUrl(
      `v1/metering/reports`,
      options?.searchParams,
    );
    const response = await this.#httpClient.get(url, {
      signal: options?.abortSignal,
      headers: robotoHeaders({
        orgId: orgId,
      }),
    });

    return response.json<MeteringReport | MeteringReport[]>();
  }
}
